let resumeData = {
  imagebaseurl: "https://github.com/johnniecletus",
  name: "John Cletus",
  role: "Full stack Developer",
  animated: {
    first: "I build scalable full stack applications that stay fast under real user load.",
    second: "I implement secure-by-default architecture with strong authentication and safe data flows.",
    third: "I engineer production-grade frontend and backend systems with clean, maintainable code.",
    fourth: "I optimize performance, SEO, and reliability so products convert and grow.",
  },
  heroStatement:
    "Full stack engineer building scalable, secure, and SEO-ready web products from architecture to deployment.",
  linkedinId: "https://www.linkedin.com/in/john-cletus-b2bb32272/",
  roleDescription:
    "Full stack engineer focused on scalable architecture, secure implementation, and high-performance product delivery across frontend and backend systems.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/john-cletus-b2bb32272/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/johnniecletus",
      className: "fa fa-github",
    },
    {
      name: "twitter",
      url: "https://twitter.com/iamjohncletus",
      className: "fa fa-twitter",
    },
  ],
  aboutme: {
    firstpara:
      "I am a graduate of the department of Mechanical Engineering from the University of Uyo with a Bachelor of Engineering degree (B.Eng.). My passion for technology has driven me to become a self-taught Full Stack Web Developer. Currently, I am immersing myself even deeper into full stack development, refining my skills and expanding my knowledge every day.",
    secondpara:
      "I firmly believe that success in life requires an unwavering obsession with one's dreams and a relentless pursuit to achieve them. My dedication to my craft is a testament to this belief, and I am committed to continuously honing my abilities and pushing the boundaries of what's possible.",
  },

  address: "Nigeria",
  website: "",
  contact: {
    email: "johncletusakpan@gmail.com",
    phone: "(+234) 7068619556",
    location: "Agege, Lagos State, Nigeria",
    formEndpoint: "https://formsubmit.co/ajax/johncletusakpan@gmail.com",
  },
  education: [
    {
      UniversityName: "University of Uyo",
      specialization: "Mechanical Engineering",
      MonthOfPassing: "Aug",
      Achievements: "Bachelor of Engineering (B.Eng.)",
    },
    {
      UniversityName: "Presbyterian Senior Science School",
      specialization: "Science",
      MonthOfPassing: "Jan",
      Achievements: "West African School Certificate (WASC)",
    },
    {
      UniversityName: "Holy Family College",
      specialization: "Arts and Science",
      MonthOfPassing: "Jan",
      Achievements: "Junior School Certificate (JSC)",
    },
  ],
  work: [

    {
      CompanyName: "Aceeoo",
      specialization:
        "Chief Technology Officer (Full Stack)",
      MonthOfLeaving: "Febuary 2026",
      YearOfLeaving: "Present",
      Achievements: `As a founding Partner, my job description is building, optimizing and scaling websites for businesses maintaining standard SEO practices and content optimization for already existing websites. Application of proper database query systems, proper caching with redis and data indexing. I also contributed to the building of the company's website, contributions made to the frontend and backend of the application. Currently we have worked with giving 3 startups visibility and those websites have gotten an average of 150 paying users in their first month.`,
    },
    {
      CompanyName: "Zendtrax Inc",
      specialization: "Lead Frontend Engineer",
      MonthOfLeaving: "November 2024",
      YearOfLeaving: "Present",
      Achievements: `
    My job description at Zendtrax is managing and building user-friendly supply chain dashboards and landing pages. I also lead the deployment and day to day management of this different dashboards. One major contribution I made was caching. As the ERP dashboard grew and data fetching became slow, I suggested to the team that we cache data on Redis and properly paginate it. This helped a system with a large dataset to be very fast for daily use by users.
  `,
    },
    {
      CompanyName: "Various Clients",
      specialization: "Full Stack Engineer (Remote, Freelance)",
      MonthOfLeaving: "January 2020",
      YearOfLeaving: "Present",
      Achievements: `I deliver high-quality fullstack web applications for clients, utilizing a range of JavaScript frameworks and libraries. My focus is on building applications with good SEO practices like proper content structure and proper keyword research, high security practices like  authentication sessions and passing token over cookies refreshed directly from the backend.`,
    },
    {
      CompanyName: "Football Predict AI.",
      specialization: "Full Stack Engineer",
      MonthOfLeaving: "November 2025",
      YearOfLeaving: "March 2026",
      Achievements: `
 I was in charge of the complete system design, backend development, and frontend development at Football predict AI. A platform where data is passed to an AI model which returns match insights based on provided data using data trends. The client needed a developer who would make him spend less on resources and instead scale as grow. He also needed a developer skilled with standard SEO practice across backend and frontend systems, the website had 200 users after the first month of lunch and 50 of them paid for the AI tool.`,
    },
    {
      CompanyName: "CozzyConnect",
      specialization: "Software Engineering Consultant ",
      MonthOfLeaving: "May 2025",
      YearOfLeaving: "November 2025",
      Achievements: `
  My job was to Guide the engineering team on workflows and deployment strategy
  `,
    },
    {
      CompanyName: "Tata Motors",
      specialization:
        "Intenship",
      MonthOfLeaving: "June 2023",
      YearOfLeaving: "Ocotber 2023",
      Achievements: `I worked as an intern during my time at Tata motors where I learnt how to carry out preventive inspections, perform routine servicing and repair damaged parts on heavy duty vehicles and light commercial vehicles.`,
    },
    {
      CompanyName: "Saharaviewpoint",
      specialization:
        "Frontend Developer",
      MonthOfLeaving: "Febuary 2023",
      YearOfLeaving: "June 2023",
      Achievements: `At Saharaviewpoint, I collaborated with the team to design and develop user and admin dashboards for the company. On the user dashboard, users can create accounts, apply for company services and monitor the status of their jobs while on the admin dashboard the admin can approve user signups, manage job requests and do so much more.`,
    },
    {
      CompanyName: "Syrex Digital Academy",
      specialization:
        "Backend Engineer",
      MonthOfLeaving: "July 2020",
      YearOfLeaving: "Febuary 2021",
      Achievements: `In this position, I worked as a backend developer responsible for building and managing the cloud infrastructure, business logic and student’s study data`,
    },
    {
      CompanyName: "Engineer Ekpa Academy ",
      specialization: "Teacher ( Onsite and Part-time )",
      MonthOfLeaving: "July 2020",
      YearOfLeaving: "January 2021",
      Achievements: `I taught in a private lesson after I graduated from high school.I developed a good bond with my students and imparted good knowledge of the subjects taught.`,
    },
    {
      CompanyName: "Microsoft",
      specialization:
        "Intenship during lockdown for High School Students (Remote)",
      MonthOfLeaving: "August 2019",
      YearOfLeaving: "Febuary 2020",
      Achievements: `I was taught and trained on how to be a software engineer. I gained valuable experience working in a virtual team environment, my problem-solving abilities improved as we were given real world problems to solve and finding creative solutions in a remote setting with limited time. Working in a remote space helped me expand my professional network for future opportunities.`,
    },






  ],
  skillsDescription:
    "All the skills I have mastered so far and those still in learning",
  skills: [
      {
      skillname: "Java",
    },
     {
      skillname: "Typescript",
    },
     {
      skillname: "Vanillajs",
    },
     {
      skillname: "Springboot",
    },
   
    {
      skillname: "Reactjs",
    },

    {
      skillname: "Redux",
    },
    {
      skillname: "Nodejs",
    },
    {
      skillname: "Nextjs",
    },
    {
      skillname: "Mongodb",
    },
    {
      skillname: "Aws",
    },
      {
      skillname: "HTML5",
    },
   
    {
      skillname: "CSS",
    },
   
  ],
  portfolio: [
    {
      name: "Sheeald",
      link: "https://github.com/johnniecletus/sheeald-backend",
      description:
        "A fintech platform built to help businesses protect the cost of goods against foreign exchange fluctuations. The backend is developed using Java Spring Boot with a MySQL database managed through Flyway migrations. Authentication is implemented using JWT (RS256) with refresh tokens, secure HTTP-only cookies, role-based authorization and business session management.",
      outcome:
        "Outcome: the platform automates payment processing, business wallet management, inventory cost protection, settlement tracking and multi-currency operations while exposing secure REST APIs for frontend and third-party integrations.",
      imgurl: "images/portfolio/api.jpg",
      category: "backend",
      stacks: ["Java 17", "Spring Boot", "Spring Security", "JWT (RS256)", "Hibernate", "", "MySQL", "Maven", "Flyway", "Oracle Cloud Infrastructure"],
    },
    {
      name: "Sheeald-App",
      link: "https://app.sheeald.com",
      description:
        "A fintech platform built to help businesses protect the cost of goods against foreign exchange fluctuations. The backend is developed using Java Spring Boot with a MySQL database managed through Flyway migrations. Authentication is implemented using JWT (RS256) with refresh tokens, secure HTTP-only cookies, role-based authorization and business session management.",
      outcome:
        "Outcome: the platform automates payment processing, business wallet management, inventory cost protection, settlement tracking and multi-currency operations while exposing secure REST APIs for frontend and third-party integrations.",
      imgurl: "images/portfolio/sheeald.png",
      category: "frontend",
      stacks: ["Next.js", "Typescript"],
    },
    {
      name: "FootballPredictAi",
      link: "https://www.footballpredictai.com",
      description:
        "A football match analysis and prediction platform that delivers AI-powered, probability-based insights using historical match data. I built the user-facing application, developed the backend REST APIs that power predictions and data flow, and created the admin dashboard for managing matches, predictions, and platform content.",
      outcome:
        "Outcome: improved prediction delivery workflow and enabled users to access AI match insights from one streamlined interface.",
      imgurl: "images/portfolio/footballpredictai.png",
      category: "fullstack",
      stacks: ["Next.js", "MongoDB", "AI", "Node.js", "Express"],
    },
    {
      name: "Acesum",
      link: "https://www.acesum.site",
      description:
        "A financial forecaster with a premium feel, that takes transaction history and generates a financial forecast. This platform is hosted on an Aws virtual server and the AWS RDS is used to house our SQL Database.",
      outcome:
        "Outcome: delivered a stable forecasting experience with production hosting and secure data persistence.",
      imgurl: "images/portfolio/acesum.png",
      category: "fullstack",
      stacks: ["Next.js", "SQL", "Knex", "Resend", "AWS"],
    },
    {
      name: "Aceeoo",
      link: "https://www.aceeoo.com",
      description:
        "A platform that offers visiblity services to startups and established companies.",
      outcome:
        "Outcome: launched a clear conversion-driven marketing site that improved business visibility for clients.",
      imgurl: "images/portfolio/aceeoo.png",
      category: "frontend",
      stacks: ["Next.js", "Node.js", "Express", "Resend"],
    },
    {
      name: "Personal Management",
      link: "https://github.com/johnniecletus/personal-management",
      description:
        "Personal Management is a Spring Boot backend for a personal finance and lifestyle manager.",
      outcome:
        "Outcome: define savings clusters for different income sources, split each income into savings buckets automatically",
      imgurl: "images/portfolio/api.jpg",
      category: "backend",
      stacks: ["Java 17", "Spring Boot", "Spring Security", "JWT (RS256)", "Hibernate", "", "MySQL", "Maven", "Flyway"],
    },
    {
      name: "Zendtrax",
      link: "https://www.zendtrax.co",
      description:
        "A marketing site for logistics services with interactive UI elements and clean responsive layouts.",
      outcome:
        "Outcome: improved lead-generation readiness with a faster and more intuitive responsive interface.",
      imgurl: "images/portfolio/zendtrax.png",
      category: "frontend",
      stacks: ["Next.js", "Tailwind", "Typescript"],
    },
    {
      name: "Algopips",
      link: "https://www.algopips.site",
      description:
        "AlgoPips is a forex automation platform concept built for traders who want algorithmic strategy execution, AI-driven signal support, and trade management workflows that stay grounded in real risk controls.",
      outcome:
        "Outcome: launched a landing page where users can make an order for the bot, applying best seo practices and form security. Ability to create seo pages on the admin panel. Secure session authentication for the single admin user.",
      imgurl: "images/portfolio/algopips.png",
      category: "fullstack",
      stacks: ["Next.js", "Express", "Zoho"],
    },
    {
      name: "Zendtrax Erp",
      link: "https://www.erp.zendtrax.co",
      description:
        "A robust dashboard to manage logistics operations, inventory, warehouses, and order processing.",
      outcome:
        "Outcome: centralized operations visibility for teams managing inventory, warehouses, and order flows.",
      imgurl: "images/portfolio/zendtrax_erp.png",
      category: "dashboard",
      stacks: [
        "Next.js",
        "Typescript",
        "Chart.js",
        "Node.js",
        "Zustand",
        "Tailwind",
      ],
    },

    {
      name: "Football Predict AI Blog",
      link: "https://blog.footballpredictai.com",
      description:
        "A modern blog platform with  content management, likes, comments and local read history tracker",
      outcome:
        "Outcome: delivered scalable content workflows with engagement features that increased user interaction.",
      imgurl: "images/portfolio/fbpaiblog.png",
      category: "fullstack",
      stacks: ["Next.js", "MongoDB", "Mongoose", "Node.js", "Express.Js"],
    },
    {
      name: "Aceson Link",
      link: "https://github.com/johnniecletus/Aceson-link-backend",
      description:
        "Rest APIs for Aceson link, a mentor and a mentee platform.",
      outcome:
        "Outcome: exposed reliable API endpoints for matchmaking, communication, and mentor-mentee lifecycle operations.",
      imgurl: "images/portfolio/api.jpg",
      category: "backend",
      stacks: ["Node.js", "MongoDB", "Mongoose", "TypeScript"],
      source: "https://github.com/johnniecletus/Aceson-link-backend",
    },
    {
      name: "Aceson EMS",
      link: "https://github.com/johnniecletus/aceson-employee-management-system",
      description:
        "Rest APIs for Aceson EMS, an employement management console",
      outcome:
        "Outcome: implemented API foundations for employee workflows including records and management operations.",
      imgurl: "images/portfolio/api.jpg",
      category: "backend",
      stacks: ["Java", "Springboot", "SQL", "Maven"],
      source: "https://github.com/johnniecletus/aceson-employee-management-system",
    }
  ],
  testimonials: [
    {
      description:
        "John was one of the few engineers I did not need to chase. He translated rough product ideas into clear deliverables, moved fast without getting careless, and kept performance in mind from the beginning.",
      name: "Founder, Lagos fintech startup",
      role: "Testimonial",
      company: "Nigeria",
      project: "Early-stage product build with frontend performance and launch readiness as priorities.",
      sample: false,
    },
    {
      description:
        "We brought him in during a messy phase of the product and he added structure almost immediately. Communication stayed direct and the quality improved.",
      name: "Operations lead, Abuja logistics team",
      role: "Testimonial",
      company: "Nigeria",
      project: "Workflow cleanup, bug reduction, and steadier release execution across a busy operations dashboard.",
      sample: false,
    },
    {
      description:
        "What stood out was his judgment. He was not just implementing, he was thinking about SEO, conversion, and what would still be maintainable six months later.",
      name: "Product manager, Port Harcourt service platform",
      role: "Testimonial",
      company: "Nigeria",
      project: "Growth-focused website improvements with stronger technical decisions behind the UI work.",
      sample: false,
    },
    {
      description:
        "John integrated into our remote workflow quickly and handled feedback with very little friction. The frontend felt more polished afterward, but the bigger win was how much more reliable the product became.",
      name: "Team lead, London SaaS company",
      role: "Testimonial",
      company: "United Kingdom",
      project: "Remote collaboration on product refinement, reliability fixes, and interface consistency.",
      sample: true,
    },
    {
      description:
        "We needed someone who could move between UI detail and backend logic without slowing the project down. He handled both sides well and was honest about tradeoffs, which made planning much easier.",
      name: "Founder, Toronto B2B startup",
      role: "Testimonial",
      company: "Canada",
      project: "Cross-functional build work spanning customer-facing flows and supporting backend implementation.",
      sample: false,
    },
    {
      description:
        "He ships with a calm, methodical style that senior teams appreciate. Even when deadlines were tight, he stayed organized, asked the right questions, and delivered work that did not need endless rework.",
      name: "Engineering manager, Berlin logistics product",
      role: "Testimonial",
      company: "Germany",
      project: "Fast-paced product iteration with emphasis on maintainability, communication, and clean delivery.",
      sample: false,
    },
  ],
};

export default resumeData;
